











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LabelInput extends Vue {
  // 输入框前面的文字
  @Prop() public label!: string;

  // 标题插槽上的额外样式
  @Prop() public labelClass!: string;

  // 内容插槽上的额外样式
  @Prop() public wrapClass!: string;

  // 标题宽度
  @Prop() public labelWidth!: string | number;

  // slot里是否为文本内容
  @Prop({ type: Boolean, default: false }) public text!: boolean;

  // 内容插槽上的样式
  public get extraWrapClass() {
    return this.text ? 'label-input-text' : '';
  }

  public get labelStyle() {
    const width = parseInt(this.labelWidth as string, 10);
    return width ? { width: `${width}px` } : { whiteSpace: 'nowrap' };
  }
}
